/**
 * @namespace {BX.UI}
 */
export default class LabelColor
{
	static DEFAULT = 'ui-label-default';
	static DANGER = 'ui-label-danger';
	static SUCCESS = 'ui-label-success';
	static WARNING = 'ui-label-warning';
	static PRIMARY = 'ui-label-primary';
	static SECONDARY = 'ui-label-secondary';
	static LIGHT = 'ui-label-light';
	static TAG_SECONDARY = 'ui-label-tag-secondary';
	static TAG_LIGHT = 'ui-label-tag-light';
	static LIGHT_BLUE = 'ui-label-lightblue';
	static LIGHT_GREEN = 'ui-label-lightgreen';
	static LIGHT_ORANGE = 'ui-label-lightorange';
	static LIGHT_YELLOW = 'ui-label-lightyellow';
	static LIGHT_RED = 'ui-label-lightred';
}